<template>
	<svg role="img" width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="LinkedIn's logo">
		<circle cx="18.5" cy="18.5" r="18" transform="rotate(-180 18.5 18.5)" stroke="#3E5974" />
		<g clip-path="url(#clip0_2600_758)">
			<path d="M14.937 15.2754H12.2188V23.9423H14.937V15.2754Z" fill="currentColor" />
			<path
				d="M22.2823 15.0825C22.1796 15.0712 22.0744 15.0631 21.9673 15.0587C20.4457 14.9967 19.5853 15.8997 19.2885 16.2848C19.2096 16.3881 19.1702 16.4544 19.1702 16.4544V15.2948H16.5703V23.9616H19.2885V19.8896C19.2885 19.3017 19.2428 18.673 19.5371 18.1389C19.7863 17.6874 20.2366 17.4613 20.7463 17.4613C22.2472 17.4613 22.2829 18.8195 22.2829 18.9485V24.0011H25.0011V18.348C25.0011 16.4137 24.018 15.2697 22.2829 15.0825H22.2823Z"
				fill="currentColor"
			/>
			<path
				d="M13.5761 14.1522C14.4465 14.1522 15.1522 13.4465 15.1522 12.5761C15.1522 11.7056 14.4465 11 13.5761 11C12.7056 11 12 11.7056 12 12.5761C12 13.4465 12.7056 14.1522 13.5761 14.1522Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2600_758">
				<rect width="13" height="13" fill="currentColor" transform="translate(12 11)" />
			</clipPath>
		</defs>
	</svg>
</template>
